module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/flat-lays/flat-lay-05-9b54bd29b68e86c3baa7a289f831725b.jpg";